export enum AgendaPointType {
  ChatMessage = 'chatMessage',
}

export interface AgendaPoint {
  type: AgendaPointType;
  minute: number;
  content: string;
}

export interface GroupSessionAgenda {
  id: string;
  accountId: string;
  agenda: AgendaPoint[];
}
